import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { shareReplay } from 'rxjs';

import { filterDefined } from '@core/common-legacy';
import { PrimaryContactEntityActions, PrimaryContactEntitySelectors } from '@core/company-data';

@Injectable({ providedIn: 'root' })
export class PrimaryContactDataService {
  private readonly store = inject(Store);

  public readonly data$ = this.store
    .select(PrimaryContactEntitySelectors.data)
    .pipe(filterDefined, shareReplay({ bufferSize: 1, refCount: true }));

  public fetch() {
    this.store.dispatch(PrimaryContactEntityActions.fetch());
  }
}
